import React, { Component } from 'react';
import ShipForm from './ShipForm';
import { getShip, getAllPilots, updateShip, getIncompleteShip } from './api';
import EditPage from './EditPage';

class EditShipPage extends Component {
  constructor(props) {
    super(props);
    this.getShipWithImage = this.getShipWithImage.bind(this);
  }
  async getShipWithImage(...args) {
    const [ship, pilots] = await Promise.all([getShip(...args), getAllPilots()]);
    const pilot = pilots.find(p => p.ship == ship.name && p.image);
    return {
      ...ship,
      image: pilot.image,
    };
  }
  render() {
    return (
      <EditPage
        getItem={this.getShipWithImage}
        saveItem={updateShip}
        formComponent={ShipForm}
        getNextItem={getIncompleteShip}
        type={`ships`}
        {...this.props}
      />
    );
  }
}

export default EditShipPage;



// WEBPACK FOOTER //
// ./src/EditShipPage.js